import { useEffect, useState } from 'react'
import { Form, FormSpy } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import styles from './ReportFiltersForm.module.css'
import { DatePickerFormField } from '../../../common/components/Form/DatePickerFormField/DatePickerFormField'
import { useDebounce } from '../../../hooks/useDebounce'
import { areObjectsEqual } from '../../../util/functional'
import { ReportFilters } from '../../../contexts/ReportsContextProvider'
import classNames from 'classnames'

type ReportFiltersProps = {
  defaultFrom?: string
  onChange: (filters: Partial<ReportFilters>) => void
  customTitle?: string
  customFrom?: string
  customTo?: string
}

export const ReportFiltersForm: React.FC<ReportFiltersProps> = ({ defaultFrom, onChange, customTitle, customFrom, customTo }) => {
  const { t } = useTranslation()

  const [filters, setFilters] = useState<ReportFilters>({ createdAtFrom: defaultFrom })
  const debouncedFilters = useDebounce(filters, 1_000)

  const initialValues: ReportFilters = {
    createdAtFrom: defaultFrom,
    createdAtUntil: undefined,
  }

  useEffect(() => {
    onChange(debouncedFilters)
  }, [onChange, debouncedFilters])

  return (
    <Form<ReportFilters> initialValues={initialValues} onSubmit={onChange}>
      {({ values, handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.filtersContainer}>
            <div
              className={classNames(
                styles.filtersTitle,
                !!(values.createdAtFrom || values.createdAtUntil) && styles.filtersTitleActive,
              )}
            >
              {customTitle ?? t('report.filters_title', 'Limit the date range')}
            </div>
          
          <DatePickerFormField
            name='createdAtFrom'
            label={customFrom ?? t('report.filter_label.created_at_from', 'Created at (from)')}
            placeholder={customFrom ?? t('report.filter_label.created_at_from', 'Created at (from)')}
            srOnlyLabel
            isClearable
            maxDate={values.createdAtUntil == null ? undefined : new Date(values.createdAtUntil)}
          />

          <DatePickerFormField
            name='createdAtUntil'
            label={customTo ?? t('report.filter_label.created_at_until', 'Created at (until)')}
            placeholder={customTo ?? t('report.filter_label.created_at_until', 'Created at (until)')}
            srOnlyLabel
            isClearable
            minDate={values.createdAtFrom == null ? undefined : new Date(values.createdAtFrom)}
          />

          <FormSpy
            onChange={(props) =>
              setFilters((prev) => (areObjectsEqual(prev ?? {}, props.values) ? prev : props.values))
            }
          />
        </form>
      )}
    </Form>
  )
}
